import React, {useState, useRef, useEffect} from 'react';
import { Toolbar, Grid, Stack, MenuItem, Button, IconButton, Paper, Box, InputAdornment } from "@mui/material";
import ReplayIcon from '@mui/icons-material/Replay';
import { Link, useNavigate } from "react-router-dom"
import { useFormik } from 'formik';
import get from "lodash/get";
import CloseIcon from '@mui/icons-material/Close';
import SaveAltIcon from '@mui/icons-material/SaveAlt'; 
import { useDispatch, useSelector } from "react-redux";
import { exportToExcel } from "react-json-to-excel";
import ImportExportIcon from '@mui/icons-material/ImportExport';
import AddIcon from '@mui/icons-material/Add';
import { useCanView } from "../../../config/hook/UserPermissions";
import Alert from "../../../components/form/Alert";
import { Download } from '@mui/icons-material';
import DowloandRoutesModal from "./DowloandRoutesModal";
import DateRangeIcon from '@mui/icons-material/DateRange';

// import InputSearch from "../../../components/form/InputSearch";
import InputText from "../../../components/form/InputText";

const ToolbarComponent = ({ setFilter, __, reload, isLoading, callBackRoute }) => {
  const route = useSelector(state => state.transactions.route);
  const [selectedFile, setSelectedFile] = useState(null); // Solo un archivo
  const inputFileRef = useRef(null); // Ref para el input
  const user = useSelector(state => state.auth.login.dataUser);
  const navigate = useNavigate();
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });
  const canView = useCanView();
  const [openModal, setOpenModal] = useState(false);
 
    const onSubmit = (values) => {
        let Filters = "";

        if (!!values.name) { Filters = `routeName@=${values.name}` }
        if (!!values.idRoute) { Filters = `${!!Filters ? `${Filters},` : ""}idRoute==${values.idRoute}` }
        setFilter(Filters)
    }

    const handleFileUpload = (event) => {
        const file = event.target.files[0]; // Obtener solo el primer archivo

        if (file) {
            const isImage = file.type.startsWith('image/');
            setSelectedFile(file); // Guardar el archivo en el estado
        }
    };

    const formik = useFormik({
        initialValues: {
            // search: "",
            idRoute: "",
            name: "",
            // isActive: get(isActive, "[0].value"),
        },
        onSubmit,
    });


    const onClear = (field) => async () => {
        await formik.setFieldValue(field, "")
        formik.submitForm()
    }


    useEffect(() => {
        if(selectedFile){
            if (selectedFile) {
                const formData = new FormData();
                formData.append("UserId", Number(get(user, "idUser"))); 
                formData.append("File", selectedFile); 
                callBackRoute(formData);
            }
            setSelectedFile(null);
        }
    }, [selectedFile]);

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }
    

    return (
        <Toolbar component={Paper} className='p-2 mb-4' sx={{ borderBottomWidth: "1px", borderBottomColor: "text.sslite", borderBottomStyle: "solid", position: "sticky", top: 0, zIndex: 100 }}>
            <Stack component="form" onSubmit={get(formik, "handleSubmit")} direction={{ sx: "column", xl: "row" }} alignItems={{ sx: "flex-start", xl: "center" }} justifyContent={{ sx: "center", xl: "space-between" }} spacing={{ sx: 1, xl: 1 }} className='w-full'>
                <Grid container spacing={1} justifyContent={{ sx: "flex-start", md: "flex-end" }}>
                    <Grid item xs="auto" justifyContent="flex-end" display="flex">
                        <Button
                            variant="contained"
                            color="success" // El color verde para el botón
                            startIcon={<DateRangeIcon />} // Icono de exportar
                            onClick={() => setOpenModal(true)}
                            // onClick={() =>  exportToExcel(route.data.data, 'Rutas')}
                        >
                            Descargar Rutas
                        </Button>
                    </Grid>
                    <Grid item xs="auto" justifyContent="flex-end" display="flex">
                        <a href={`/PlantillaRuta.csv`} download>
                            <Button
                            variant="contained"
                            color="warning" 
                            startIcon={<Download/>} 
                            >
                            Descargar CSV
                            </Button>
                        </a>
                    </Grid>
                    {/* <Grid item xs={6} md={4} lg={3} xl={2}>
                        <InputText
                            name={"idRoute"}
                            formik={formik}
                            labelInput={__(`toolbar.filter.idRoute`)}
                            placeholder={""}
                            disabled={isLoading}
                            onBlur={get(formik, "submitForm", () => { })}
                            InputProps={{ endAdornment: <InputAdornment position="end"><IconButton aria-label="close" size="small" edge="end" onClick={onClear("idRoute")}><CloseIcon fontSize="inherit" /></IconButton></InputAdornment> }}
                        />
                    </Grid>
                    <Grid item xs={6} md={4} lg={3} xl={2}>
                        <InputText
                            name={"name"}
                            formik={formik}
                            labelInput={__(`toolbar.filter.name`)}
                            placeholder={""}
                            disabled={isLoading}
                            onBlur={get(formik, "submitForm", () => { })}
                            InputProps={{ endAdornment: <InputAdornment position="end"><IconButton aria-label="close" size="small" edge="end" onClick={onClear("name")}><CloseIcon fontSize="inherit" /></IconButton></InputAdornment> }}
                        />
                    </Grid> */}
                    <Grid item xs={12} md={4} lg={3} xl={2}>
                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                            <Button className='w-[100px] min-w-[100px]' variant="contained" color="secondary" startIcon={<AddIcon/>} onClick={() => {
                                if (canView("TRANSACCIONES/RUTAS", "add")) {
                                    navigate("new");
                                } else {
                                    setAlert({
                                        open: true,
                                        title: "Permiso Denegado.",
                                        subtitle: (<ul> • No tienes permiso para agregar nuevas rutas.</ul>),
                                        type: "error",
                                        btn: __(`${module}.actions.close`),
                                        func: closeAlert
                                    })
                                }
                            }}>{__(`toolbar.btn`)}</Button>
                            <Button
                                className='w-[100px] min-w-[100px]'
                                variant="contained"
                                sx={{ backgroundColor: '#00BFFF', color: 'white' }}
                                startIcon={<ImportExportIcon />}
                                onClick={() => {
                                if (canView("TRANSACCIONES/RUTAS/IMPORTAR", "add")) {
                                    inputFileRef.current.click()
                                } else {
                                    setAlert({
                                        open: true,
                                        title: "Permiso Denegado.",
                                        subtitle: (<ul> • No tienes permiso para importar nuevas rutas.</ul>),
                                        type: "error",
                                        btn: __(`${module}.actions.close`),
                                        func: closeAlert
                                    })
                                }  
                                }}> Importar
                            </Button>
                            <input
                                type="file"
                                accept=".csv"
                                ref={inputFileRef}
                                hidden
                                onChange={handleFileUpload}
                            />
                        </Stack>
                    </Grid>
                    <Grid item xs="auto" justifyContent="flex-end" display="flex">
                        <Button
                            variant="contained"
                            color="success" // El color verde para el botón
                            startIcon={<SaveAltIcon />} // Icono de exportar
                            onClick={() =>  exportToExcel(route.data.data, 'Rutas')}
                            disabled={!route?.data.data || route.data.data.length === 0}
                        >
                            Exportar
                        </Button>
                        <IconButton title={__(`toolbar.reload`)} onClick={reload}><ReplayIcon sx={{ transform: "scaleX(-1) rotate(-45deg)" }} /></IconButton>
                    </Grid>
                </Grid>
                <Alert
                    title={get(alert, "title")}
                    subtitle={get(alert, "subtitle")}
                    btn1={{ func: get(alert, "func") }}
                    btn2={{}}
                    type={get(alert, "type")}
                    openAlert={get(alert, "open")}
                    closeAlert={closeAlert}
                />
                <DowloandRoutesModal
                    __={__}
                    open={openModal}
                    close={() => setOpenModal(false)}
                />
            </Stack>
        </Toolbar>
    )
}

export default ToolbarComponent